import { RuleConfiguration } from '@blk/aw-bff-typescript-models';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { awBffApi } from './Base';

interface GetComplRulesParams {
  pkg: string;
}

export async function getComplRules(params: GetComplRulesParams) {
  const path = '/compl-rule';
  const response = await awBffApi.get<AGraphWrappedType<RuleConfiguration[], 'rules'>>(path, { params });
  return unwrapAGraphResponse(response, 'rules');
}
